import { useMutation, useQueryClient } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { API_MEDICAL_HISTORY } from 'services/dataService/ccmResources';
import { showResult } from 'infrastructure/hooks/utils';

import { PAST_MEDICAL_HISTORY_KEY } from './use-get-medical-history';

import type { IMedicalHistory } from 'infrastructure/interfaces';

interface DataProps {
  patientGuid: string;
  record: string;
  trackingPlatform?: string | null;
}

const addMedicalHistoryFn = async (postData: DataProps) => {
  const url = API_MEDICAL_HISTORY;
  const { error, data } = await dataService.createOne<IMedicalHistory>(
    url,
    postData,
  );

  if (error) {
    showResult(error);
    throw new Error(error);
  }

  return data;
};

export const useAddMedicalHistory = () => {
  const queryClient = useQueryClient();
  const { mutate, isLoading, ...other } = useMutation({
    mutationFn: async (postData: DataProps) => addMedicalHistoryFn(postData),
    onSuccess() {
      queryClient.invalidateQueries({ queryKey: [PAST_MEDICAL_HISTORY_KEY] });
      showResult();
    },
  });
  return {
    addMedicalHistory: mutate,
    addLoading: isLoading,
    ...other,
  };
};
